import { InputVariables } from './LogInForm.props';

export const getFormVariables = (isProcessManagementForm: boolean): InputVariables => ({
  variant: isProcessManagementForm ? 'outlined' : 'standard',
  userLabel: isProcessManagementForm ? '' : 'User',
  passwordLabel: isProcessManagementForm ? '' : 'Password',
});
